var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import updateServiceEntry from '../../requests/service/updateServiceEntry';
/**
 *
 */
var UpdateServiceEntryCommand = /** @class */ (function (_super) {
    __extends(UpdateServiceEntryCommand, _super);
    function UpdateServiceEntryCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param data Object
     * @param organisation OrganisationModel
     * @param serviceEntryModel ServiceEntryModel
     * @param intl
     * @return {*}
     */
    UpdateServiceEntryCommand.prototype.execute = function (data, organisation, serviceEntryModel, intl) {
        this.data = data;
        this.intl = intl;
        this.serviceEntryModel = serviceEntryModel;
        var promise = updateServiceEntry(data, organisation, serviceEntryModel);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateServiceEntryCommand.prototype.then = function (response) {
        this.serviceEntryModel.update(response);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.entry.updated' }), 'dark', true);
        Signals.ServiceEntryUpdated.dispatch(this.serviceEntryModel);
    };
    return UpdateServiceEntryCommand;
}(Command));
export default UpdateServiceEntryCommand;
